import * as e from "react";
const d = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 490 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M69.427 175.493a100 100 0 0139.904-89.885l63.206-46.954a99.998 99.998 0 0190.206-14.938l118.68 38.108c46.508 14.934 75.421 61.283 68.384 109.62l-15.823 108.671a100 100 0 01-54.955 75.392l-82.057 40.207a99.995 99.995 0 01-69.069 7.007l-72.294-18.72c-40.677-10.534-70.43-45.373-74.469-87.197L69.427 175.493z",
      fill: "url(#sleeping-lamp_svg__paint0_linear_1022_760)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M246.665 114.183h-62.318l-28.219 85.834h118.757l-28.22-85.834z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M183.171 114.183h62.319l28.219 85.834h-7.21a6.156 6.156 0 00-.22-.888l-24.275-73.834a6 6 0 00-5.7-4.126h-53.631a5.99 5.99 0 00-1.9.308l2.398-7.294z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M214.918 200.017v59.967", stroke: "#2d6ded", strokeWidth: 2 }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M166.534 267.984a7 7 0 017-7h82.768a7 7 0 017 7v9.813h-96.768v-9.813z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M168.594 264.687h80.653a8 8 0 018 8v6.11h4.704v-10.813a8 8 0 00-8-8h-78.065a8.003 8.003 0 00-7.292 4.703z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "circle",
    {
      cx: 183.171,
      cy: 221.182,
      r: 7.231,
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M179.644 229.072a8.235 8.235 0 000-15.78 8.23 8.23 0 0110.582 7.89 8.23 8.23 0 01-10.582 7.89z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M183.171 200.017v14.11", stroke: "#2d6ded", strokeWidth: 2 }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M331.894 344.137c-5.432-5.784-5.147-14.878.638-20.31 5.785-5.432 14.878-5.147 20.31.638l4.098 4.363-20.949 19.673-4.097-4.364z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M361.994 334.211a1 1 0 01-.045 1.413l-19.49 18.303a1 1 0 01-1.413-.044l-5.598-5.961 20.948-19.672 5.598 5.961z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 366.033,
      y: 350.189,
      width: 2.794,
      height: 13.72,
      rx: 1.397,
      transform: "rotate(136.8 366.033 350.189)",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 358.713,
      y: 357.277,
      width: 2.794,
      height: 13.72,
      rx: 1.397,
      transform: "rotate(136.8 358.713 357.277)",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M330.871 341.77c-4.867-5.183-4.611-13.33.571-18.197a12.824 12.824 0 017.508-3.424 12.87 12.87 0 00-3.03 2.122c-5.183 4.867-5.439 13.014-.572 18.197l8.79 9.248-3.02 2.836-10.247-10.782z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 301.386,
      y: 193.423,
      width: 62.269,
      height: 62.269,
      rx: 7,
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "circle",
    {
      cx: 332.52,
      cy: 224.557,
      r: 19.957,
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M326.168 241.597c-5.128-3.338-8.518-9.12-8.518-15.694 0-10.333 8.377-18.711 18.711-18.711 1.915 0 3.763.288 5.503.823a18.619 18.619 0 00-10.193-3.018c-10.334 0-18.711 8.377-18.711 18.711 0 8.419 5.56 15.539 13.208 17.889z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M339.834 207.791c5.127 3.337 8.517 9.12 8.517 15.693 0 10.334-8.377 18.711-18.711 18.711-1.915 0-3.763-.287-5.503-.822a18.624 18.624 0 0010.193 3.018c10.334 0 18.711-8.377 18.711-18.711 0-8.419-5.559-15.539-13.207-17.889z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement("circle", { cx: 325.534, cy: 224.557, r: 2.794, fill: "#2d6ded" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 339.506, cy: 224.557, r: 2.794, fill: "#2d6ded" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M120.154 277.649h254.979M191.261 269.266l-4.52 16.869c-4.701 17.544-6.044 49.006 48.509 37.587l53.429-13.166c10.162-2.977 30.875-3.505 43.73 13.166",
      stroke: "#2d6ded",
      strokeWidth: 2,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("circle", { cx: 190.71, cy: 269.266, r: 4.191, fill: "#2d6ded" }),
  /* @__PURE__ */ e.createElement("mask", { id: "sleeping-lamp_svg__a", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M234.72 155.29c0-.747-1.033-.783-1.374-.118-1.764 3.439-5.514 5.812-9.855 5.812s-8.091-2.373-9.855-5.812c-.194-.378-.777-.307-.777.118 0 5.662 4.894 10.252 10.931 10.252 6.036 0 10.93-4.59 10.93-10.252z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M234.72 155.29c0-.747-1.033-.783-1.374-.118-1.764 3.439-5.514 5.812-9.855 5.812s-8.091-2.373-9.855-5.812c-.194-.378-.777-.307-.777.118 0 5.662 4.894 10.252 10.931 10.252 6.036 0 10.93-4.59 10.93-10.252z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M233.346 155.172l-2.669-1.369 2.669 1.369zm-2.669-1.369c-1.236 2.409-3.938 4.181-7.186 4.181v6c5.435 0 10.232-2.975 12.525-7.443l-5.339-2.738zm-7.186 4.181c-3.247 0-5.949-1.772-7.186-4.181l-5.338 2.738c2.292 4.468 7.09 7.443 12.524 7.443v-6zm.299 4.558c-4.564 0-7.931-3.425-7.931-7.252h-6c0 7.497 6.421 13.252 13.931 13.252v-6zm7.93-7.252c0 3.827-3.367 7.252-7.93 7.252v6c7.509 0 13.93-5.755 13.93-13.252h-6zm-15.415-1.487c-.737-1.438-2.242-2.027-3.546-1.844-1.411.197-2.9 1.392-2.9 3.331h6c0 .624-.232 1.292-.732 1.817a2.624 2.624 0 01-1.536.794c-.965.135-2.081-.3-2.624-1.36l5.338-2.738zm19.711 2.738a2.134 2.134 0 01-2.047 1.154 2.384 2.384 0 01-1.494-.668 2.432 2.432 0 01-.755-1.737h6a3.57 3.57 0 00-1.089-2.591 3.61 3.61 0 00-2.278-.991 3.865 3.865 0 00-3.676 2.095l5.339 2.738z",
      fill: "#2d6ded",
      mask: "url(#sleeping-lamp_svg__a)"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "sleeping-lamp_svg__b", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M207.681 155.29c0-.747-1.033-.783-1.374-.118-1.764 3.439-5.514 5.812-9.855 5.812s-8.091-2.373-9.855-5.812c-.194-.378-.777-.307-.777.118 0 5.662 4.894 10.252 10.93 10.252 6.037 0 10.931-4.59 10.931-10.252z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M207.681 155.29c0-.747-1.033-.783-1.374-.118-1.764 3.439-5.514 5.812-9.855 5.812s-8.091-2.373-9.855-5.812c-.194-.378-.777-.307-.777.118 0 5.662 4.894 10.252 10.93 10.252 6.037 0 10.931-4.59 10.931-10.252z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M206.307 155.172l2.669 1.369-2.669-1.369zm-2.669-1.369c-1.237 2.409-3.939 4.181-7.186 4.181v6c5.434 0 10.232-2.975 12.524-7.443l-5.338-2.738zm-7.186 4.181c-3.248 0-5.95-1.772-7.186-4.181l-5.339 2.738c2.292 4.468 7.09 7.443 12.525 7.443v-6zm.298 4.558c-4.563 0-7.93-3.425-7.93-7.252h-6c0 7.497 6.421 13.252 13.93 13.252v-6zm7.931-7.252c0 3.827-3.367 7.252-7.931 7.252v6c7.51 0 13.931-5.755 13.931-13.252h-6zm-15.415-1.487a3.447 3.447 0 00-3.546-1.844c-1.411.197-2.9 1.392-2.9 3.331h6c0 .624-.233 1.292-.733 1.817a2.621 2.621 0 01-1.536.794c-.964.135-2.08-.3-2.624-1.36l5.339-2.738zm19.71 2.738a2.133 2.133 0 01-2.046 1.154 2.38 2.38 0 01-1.494-.668 2.432 2.432 0 01-.755-1.737h6a3.57 3.57 0 00-1.089-2.591 3.612 3.612 0 00-2.278-.991 3.864 3.864 0 00-3.676 2.095l5.338 2.738z",
      fill: "#2d6ded",
      mask: "url(#sleeping-lamp_svg__b)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M144.906 160.657a1 1 0 01-1-1v-.823c0-.21.066-.414.188-.584l8.731-12.145h-6.958a1.291 1.291 0 110-2.582h9.613a1 1 0 011 1v.756c0 .21-.066.414-.188.584l-8.765 12.179h7.612a1.308 1.308 0 110 2.615h-10.233zM129.537 149.111a1 1 0 01-1-1v-.605c0-.208.065-.41.186-.58l7.742-10.867h-6.174a1.159 1.159 0 010-2.316h8.423a1 1 0 011 1v.544a.997.997 0 01-.186.581l-7.772 10.898h6.756a1.172 1.172 0 010 2.345h-8.975z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M139.582 127.832a1.002 1.002 0 00-.147.522v.477a1 1 0 001 1h5.393a1.133 1.133 0 100-2.265h-3.603l4.607-7.517c.096-.157.148-.338.148-.522v-.432a1 1 0 00-1-1h-5.051a1.121 1.121 0 000 2.243h3.242l-4.589 7.494z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement("circle", { cx: 208.873, cy: 179.15, r: 7.684, fill: "#2d6ded" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.69 84.494a1.746 1.746 0 110 3.492h-6.987v6.986a1.746 1.746 0 11-3.492 0v-6.986h-6.986a1.746 1.746 0 010-3.492h6.986v-6.986a1.746 1.746 0 013.492 0v6.986h6.986zM276.984 229.796a1.747 1.747 0 010 3.493h-6.986v6.986a1.746 1.746 0 11-3.493 0v-6.986h-6.986a1.746 1.746 0 010-3.493h6.986v-6.985a1.747 1.747 0 113.493 0v6.985h6.986z",
      fill: "#FAB800",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M476.775 240.974a1.745 1.745 0 110 3.492h-6.986v6.986a1.747 1.747 0 11-3.493 0v-6.986h-6.985a1.746 1.746 0 110-3.492h6.985v-6.986a1.747 1.747 0 113.493 0v6.986h6.986zM398.535 316.419a1.746 1.746 0 110 3.493h-6.986v6.986a1.746 1.746 0 01-3.493 0v-6.986h-6.985a1.747 1.747 0 110-3.493h6.985v-6.985a1.747 1.747 0 113.493 0v6.985h6.986zM71.603 235.536a1.746 1.746 0 110 3.493h-6.985v6.985a1.747 1.747 0 11-3.493 0v-6.985h-6.986a1.747 1.747 0 010-3.493h6.986v-6.986a1.746 1.746 0 013.493 0v6.986h6.986z",
      fill: "#FAB800",
      opacity: 0.8
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M367.449 93.226c7.716 0 13.971 6.255 13.971 13.971s-6.255 13.972-13.971 13.972c-7.717 0-13.972-6.256-13.972-13.972 0-7.716 6.255-13.971 13.972-13.971zm0 5.588a8.383 8.383 0 100 16.766 8.383 8.383 0 000-16.766zM199.791 10.794c7.717 0 13.972 6.255 13.972 13.972 0 7.716-6.255 13.971-13.972 13.971-7.716 0-13.971-6.255-13.971-13.971s6.255-13.972 13.971-13.972zm0 5.589a8.383 8.383 0 00-8.382 8.383 8.383 8.383 0 1016.765 0 8.383 8.383 0 00-8.383-8.383zM136.92 333.534c7.716 0 13.971 6.256 13.971 13.972 0 7.716-6.255 13.971-13.971 13.971s-13.971-6.255-13.971-13.971 6.255-13.972 13.971-13.972zm0 5.589a8.383 8.383 0 100 16.766 8.383 8.383 0 000-16.766z",
      fill: "#FAB800",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "linearGradient",
    {
      id: "sleeping-lamp_svg__paint0_linear_1022_760",
      x1: 263,
      y1: 431.594,
      x2: 262.46,
      y2: 24.795,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#2d6ded", stopOpacity: 0.5 }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#2d6ded", stopOpacity: 0.03 })
  ))
), t = d;
export {
  t as default
};
